import React from "react";
import { NavigatorAction } from "../../../flux";
import Router from "../router";
import Header from "../header";
import Assignments from "./assignments";
import Library from "./library";
import CookieCat from "../../../../accept-cookies/banner";
import setTitle from "../../../../../utils/set-title";

class AssignmentBooks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: null
    };
  }

  componentDidMount() {
    document.title = setTitle(
      Fraction.Brand,
      i18n.t("assignments.assignment-creator")
    );
  }

  componentWillUnmount() {
    NavigatorAction.reset();
  }

  _close() {
    Fraction.Router.setRoute("/");
    Fraction.Helpers.removeModal();
  }

  _showActions(e, uuid) {
    e.stopPropagation();
    this.setState(prevState => {
      if (prevState.active) {
        return { active: null };
      }
      return { active: uuid };
    });
  }

  render() {
    return (
      <div id="assignments" onClick={e => this.setState({ active: null })}>
        <CookieCat />
        <div id="books-navigation">
          <Header
            title={i18n.t("assignments.assignment-creator")}
            close={this._close.bind(this)}
          />
          <Router>
            <Assignments
              initialRoute={true}
              showActions={this._showActions.bind(this)}
              active={this.state.active}
              route="assignments"
            />
            <Library route="library" />
          </Router>
        </div>
      </div>
    );
  }
}

module.exports = AssignmentBooks;
